/**
 * 模組頁面代碼:
 * 模組說明: 隱私權政策
 * @module PrivacyContainer
 */
// ----- import from npm modules -----
import parse from 'html-react-parser';

// ----- import from local libraries -----
import {
    React,
    PropTypes,
    connect,
    BaseComponent,
    AccessModeEnums,
} from '../../../components/BaseComponent';

// ----- import from local components -----
import Header from './Header';
import Footer from './Footer';
import ScrollLink from '../../../components/ScrollLink';
import { MessageModal, MessageModalModeEnums } from '../../../components/MessageModal';

// ----- import from local actions -----
import { getPrivacyPolicy } from '../../../redux/actions/AccessActions';

class PrivacyContainer extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            message: { mode: MessageModalModeEnums.ERROR, title: '', body: '' },
        };
        this.messageModalRef = React.createRef();
        this.messageModal = null;
        this.toggleMessageModal = this.toggleMessageModal.bind(this);
    }

    toggleMessageModal(isShow, mode = MessageModalModeEnums.ERROR, title = '', message = '請先登入') {
        if (this.messageModal) {
            if (isShow) {
                let body = message;
                const statusCode = message?.code || '';
                if (statusCode !== '') {
                    body = `[ ${statusCode} ] ${message.message}`;
                }
                this.setState({ message: { mode: mode, title: title, body: body }});
                this.messageModal.show();
            } else {
                this.messageModal.hide();
            }
        }
    }

    componentDidMount() {
        this.loadContent();
        this.messageModal = new bootstrap.Modal(this.messageModalRef.current);
    }

    async loadContent() {
        try {
            await this.props.getPrivacyPolicy();
        } catch (error) {
            console.error('Error loading privacy content:', error);
        }
    }

    componentWillUnmount() {
        if (this._anchorClickHandlerTarget) {
            this._anchorClickHandlerTarget.removeEventListener('click', this._anchorClickHandler);
        }
        this._anchorClickHandler = null;
        this._anchorClickHandlerTarget = null;
        this.toggleMessageModal(false);
    }

    toggleLoginMessageModal = (isShow) => {
        this.toggleMessageModal(isShow, MessageModalModeEnums.INFO, '登入提示', '請先登入');
    }

    defaultContent() {
        this._anchorClickHandler = (e) => {
            const anchor = e.target.closest('a[href^="#"]');
            if (!anchor) return;
            if (anchor.closest('.gs18-Header__Hamburger')) return;
            // NavLink 會渲染成 <a> 且有 data attributes
            const href = anchor.getAttribute('href') || anchor.getAttribute('to');
            if (!href || href === '#') return;
            // 只支援 id selector
            const target = document.querySelector(href);
            if (target) {
                e.preventDefault();
                const top = target.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({ top, behavior: 'smooth' });
            }
        };
        // 建議加在內容區
        const content = document.querySelector('.m__contents');
        if (content) {
            content.addEventListener('click', this._anchorClickHandler);
            this._anchorClickHandlerTarget = content;
        }

        return (
            <section className="static-content">
                <div className="static-content__head">
                    <h2>隱私權政策</h2>
                    只要您透過本網站提供個人情報，即視同您已同意並理解本政策，故請詳閱本政策內容。<br />
                    <br />
                </div>
                <div className="static-content__body">
                    <div className="static-content__menu">
                        {/*<a href="#"><i className="fa fa-chevron-circle-down"></i>1.個人資料處理原則</a>*/}
                        <ScrollLink to="#a01"><i className="fa fa-chevron-circle-down"></i>1.個人資料處理原則</ScrollLink>
                        {/*<a href="#a02"><i className="fa fa-chevron-circle-down"></i>適用範圍</a>*/}
                        <ScrollLink to="#a02"><i className="fa fa-chevron-circle-down"></i>2.個人資料之蒐集</ScrollLink>
                        {/*<a href="#a03"><i className="fa fa-chevron-circle-down"></i>資料的蒐集與使用方式</a>*/}
                        <ScrollLink to="#a03"><i className="fa fa-chevron-circle-down"></i>3.資料的蒐集與使用方式</ScrollLink>
                        {/*<a href="#a04"><i className="fa fa-chevron-circle-down"></i>個人資料的類別</a>*/}
                        <ScrollLink to="#a04"><i className="fa fa-chevron-circle-down"></i>4.個人資料的類別</ScrollLink>
                        {/*<a href="#a05"><i className="fa fa-chevron-circle-down"></i>您的權利</a>*/}
                        <ScrollLink to="#a05"><i className="fa fa-chevron-circle-down"></i>5.您的權利</ScrollLink>
                        {/*<a href="#a06"><i className="fa fa-chevron-circle-down"></i>隱私權政策之修訂</a>*/}
                        <ScrollLink to="#a06"><i className="fa fa-chevron-circle-down"></i>6.隱私權政策之修訂</ScrollLink>
                    </div>
                    <div className="static-content__items">
                        <div id="a01" className="static-content__item">
                            <h4>1.個人資料處理原則</h4>
                            <p>1.1台灣三菱電梯股份有限公司（以下簡稱我們/我們的） 致力於保護客戶和使用者 （以下簡稱您/您的）之隱私。本隱私條款（以下簡稱本條款）旨在告知您我們如何收集、使用及分享您選擇提供給我們的個人資料。</p>
                            <p>1.2如果您是我們的既有客戶，有關我們如何使用您的個人資料之詳細資訊，將載明於您與我們簽訂的合約中。當我們收集您的個人資料時，可能會另外提供進一步之通知，說明某些預定用途，並提供您選擇同意或拒絕該等用途的權利。</p>
                            <p>1.3當我們蒐集您的個人資料時，將依照個案實際情況向您說明以下事項：<br />
                                (a) 提供個人資料是否為法律要求、合約要求或簽訂合約時附帶的必需要求。<br />
                                (b) 您是否有義務提供個人資料。<br />
                                (c) 未能提供個人資料可能產生之結果。<br />
                                (d) 是否採用自動化決策。
                            </p>
                            <p>1.4我們的網站可能包含其他第三方網站連結。如果您點擊這些連結並造訪這些第三方網站，請留意對方之隱私權政策，我們對於對方之政策或其對您的個人資料之處理不承擔任何責任。您在向第三方網站提交任何個人資料前，請先自行查看他們的相關政策。</p>
                            <p>1.5本條款旨在說明我們的隱私權實務，其涵蓋範圍如下：<br />
                                (a) 個人資料之蒐集：我們蒐集之和您相關的資訊。<br />
                                (b) 個人資料之使用：我們如何使用您的個人資料。<br />
                                (c) 個人資料之保護：我們如何保護您的個人資料。<br />
                                (d) 您的權利。<br />
                                (e) 關於隱私權條款變更。
                            </p>
                        </div>
                        <div id="a02" className="static-content__item">
                            <h4>2.個人資料之蒐集</h4>
                            <p>我們可能會蒐集下列全部或部分和您相關的個人資料：</p>
                            <p>(a) 您提供給我們的資訊：<br />
                                在您與我們互動時，我們可能會要求您提供個人資料：<br />
                                (i)  在您洽詢服務、購買或聯繫維修我們的產品時，我們可能會要求您提供姓名、地址、聯絡人詳細資訊、電話號碼、電子郵件地址和付款資訊等資訊。<br />
                                (ii)  如果您透過我們其中一個網站上的聯絡表單與我們聯絡，我們可能會記錄某些資訊，例如您的姓名、地址、公司聯絡人詳細資訊、電話號碼、電子郵件地址和其他資訊。我們也可能保留您的詢問記錄和我們的回覆記錄。<br />
                                (iii) 我們可能會請您完成用於研究目的之調查。若是這種情況，我們可能會收集您的姓名、地址、公司聯絡人詳細資訊、電話號碼、電子郵件地址、出生日期、聯絡人詳細資訊和其他資訊。<br />
                                (iv)  您為了使用我們的線上服務而建立帳戶時，我們可能會要求您提供姓名、地址、公司聯絡人詳細資訊、電話號碼、電子郵件地址、出生日期、聯絡人詳細資訊等資訊。
                            </p>
                            <p>(b)其他來源提供的資訊：<br />
                                我們可能會從公開來源和第三方收集您的個人資料。
                            </p>
                            <p>(c) 網站和通訊用途：<br />
                            我們可能會收集您造訪我們網站所留下的詳細資訊，以及透過Cookie和其他追蹤技術收集的資訊，包括但不限於您的IP位址和網域名稱、您的瀏覽器版本和作業系統、流量資料、位置資料、網路記錄檔和其他通訊資料，以及您存取的資源。
                            </p>
                        </div>
                        <div id="a03" className="static-content__item">
                            <h4>3.個人資料之使用</h4>
                            <p>3.1我們將明確說明所蒐集個人資料的使用目的，並依據相關法律規定，說明我們處理該等資料所依據的法律基礎。</p>
                            <p>3.2我們應遵守中華民國(台灣)之《個人資料保護法》，亦應遵守國際間的個人資料保護法規，例如歐盟《一般資料保護規則》（GDPR）。我們對個人資料之處理係基於GDPR及其他適用法律所載明的特定法律依據（各項依據的完整說明請見*1）。請注意，除了下方所列之揭露情形外，我們亦可能基於本條款中說明的目的，將個人資料提供予代表我們執行業務之服務提供者、承包商、代理人、顧問（例如法律、財務、商務或其他領域）以及本公司關係企業</p>
                            <p>*1<br />
                                (a)有效的溝通和商業目的：我們可能會使用您的個人資料來執行我們的業務，包括回應您的詢問或與您聯繫，或為履行您與我們之間的協議所生的義務。使用正當性之依據：契約之履行、正當利益（使我們能履行義務，並向您提供服務）。<br />
                                (b)提供您行銷資料：若您選擇接收行銷資訊，我們可能會使用您的個人資料向您提供最新消息與優惠內容。我們亦可能透過郵寄、電子郵件、簡訊、電話或傳真等方式，向您行銷我們或我們的合作夥伴之產品與服務。在法律有規範之情形下，我們會於蒐集資料時徵得您的同意，方進行此類行銷活動。我們會在每封電子行銷訊息中提供取消訂閱或拒收後續通知的選項。您也可以透過聯絡我們來與我們聯繫，告知不再接收相關訊息。使用正當性之依據：同意、正當利益（讓您隨時掌握我們產品與服務的最新資訊）。<br />
                                (c)研發目的：我們可能會分析您的個人資料，以進一步瞭解您對我們的產品和服務之需求，進而開發所需的產品和服務。使用正當性之依據：合法利益 (使我們能夠改善我們的服務)。<br />
                                (d)檢視特定活動：我們可能會使用您的個人資料來檢視詢問與交易情況，以確保服務品質及程序合規，並防範詐欺行為。使用正當性之依據：法律義務、法律請求、合法利益 (確保我們服務的品質和合法性)。<br />
                                (e)變更通知：我們可能會使用您的個人資料，來通知您我們的產品和服務的變更。使用正當之依據：正當利益 (通知您我們服務的相關變更)。<br />
                                (f)確保網站內容具有實質相關性：我們可能會使用您的個人資料，來確保我們以最有效的方式為您和您的裝置呈現我們網站的內容；這可能包括將您的資料提供給業務合作夥伴、供應商及／或服務提供者。使用正當性之依據：正當利益 (允許我們向您提供網站上的內容和服務)
                                (g)重組或調整我們的業務運作：如果我們：(i)需要將全部或部分業務出售第三方而進行協商；(ii)被第三方收購；或(iii)進行業務重組，可能需要在盡職調查過程中，將您的部分或全部個人資料移轉給相關第三方（或其顧問），以供其評估擬議中的交易或重組。此外，在交易完成或重組後，我們亦可能需要將您的個人資料移轉給新的實體或第三方，以便他們能依據本條款中所載的相同目的使用您的資料。使用正當性之依據：正當利益（使我們得以調整或變更業務）。<br />
                                (h)因應法令或主管機關要求之義務：我們可能會處理您的個人資料，以遵循相關主管機關的規定或與主管機關進行必要聯繫。這可能包括在面對來自全球各地的主管機關、法院或執法機關的查詢、法律程序或調查時，向第三方、法院及/或主管機關與執法機關揭露您的個人資料，或於法律強制要求時進行揭露。在法律允許的情況下，我們將會先向您提出請求或通知您，除非該通知將妨礙犯罪預防或偵查。使用正當性之依據：法律義務、法律請求、正當利益（配合執法機關及主管機關）。
                            </p>
                        </div>
                        <div id="a04" className="static-content__item">
                            <h4>4.個人資料之保護</h4>
                            <p>網際網路安全性</p>
                            <p>4.1透過網際網路或網站傳輸資料無法保證完全不受侵入。然而，我們依據個人資料保護相關法令，採取商業上合理的實體、電子及程序性安全措施，以保護您的個人資料。</p>
                            <p>4.2您提供給我們的所有資訊，將儲存在我們的伺服器上，或儲存在經我們驗證符合公司管理標準的可信第三方服務提供者所設置的安全伺服器中，並依據我們的資訊安全政策與標準進行存取與使用。若我們已提供（或您自行設定）可用以存取本網站特定區域的密碼，您有責任妥善保管該密碼，並遵守我們另行通知您的相關資安作業規範。提醒您，請勿與他人分享您的密碼。</p>
                            <p>儲存限制</p>
                            <p>4.3我們對個人資料的保存期間，係依據業務需求及法律規定而定。我們會在達成蒐集該資料時所聲明的處理目的，以及其他依法許可且相關的目的所需期間內，保留個人資料。例如，我們可能會保留特定交易紀錄與往來資料，直到該筆交易可能產生權利主張的時效屆滿，或為遵守主管機關關於資料保存的規定而保留。當個人資料不再需要時，我們將採取不可逆的匿名化處理（並可能在匿名化後持續保留及使用該資料），或將資料安全銷毀。</p>
                        </div>
                        <div id="a05" className="static-content__item">
                            <h4>5.您的權利</h4>
                            <p>行銷</p>
                            <p>5.1為了依據您的需求或興趣，調整我們網站的線上行銷內容，我們會使用相關技術，自動追蹤資訊，例如您在我們網站上的瀏覽紀錄、您點擊的電子郵件連結，或您所使用的行動應用程式。</p>
                            <p>5.2您有權要求我們不將您的個人資料用於行銷目的（包括上述行為）。您可以透過不勾選我們蒐集個人資料表單中的特定選項，來行使此項拒絕權。您亦可隨時透過「聯絡我們」，聯繫我們行使本項權利。</p>
                            <p>資料更新</p>
                            <p>5.3我們將盡合理努力確保您的個人資料正確性。由於這需要您的協助，若您提供的個人資料有任何變更，可透過「聯絡我們」或通知我們據點的服務人員進行更新。</p>
                            <p>您的權利</p>
                            <p>5.4若您對我們使用您的個人資料有任何疑問，請透過「聯絡我們」或與我們據點的服務人員聯繫。在特定情況下，您有權要求我們：< br />
                                (a)  提供您關於我們如何使用您資料的進一步說明；< br />
                                (b)  提供您已提供給我們的資料副本（可能須支付副本製作費）；< br />
                                (c)  更新我們所持有之個人資料中的任何錯誤（請參閱第5.3條）；< br />
                                (d)  刪除我們已無合法依據使用的個人資料；< br />
                                (e)  若資料處理係基於您的同意，您有權撤回同意，使我們停止相關處理（行銷部分請參閱第5.2條）；< br />
                                (f)  反對我們基於正當利益所進行的個人資料處理，但若我們處理的理由明顯高於對您個人資料保護權益的影響時除外；以及在申訴調查期間，限制我們使用您的資料的方式。
                            </p>
                            <p>5.5您行使上述權利時，可能會受到特定例外情形的限制，以維護公共利益（例如：防止或偵查犯罪）及我們的合法權益（例如：維持法律上之保密權利）。若您行使任何上述權利，我們將會驗證您行使權利的正當性，並在多數情況下會於一個月內回覆。</p>
                            <p>5.6若您對我們使用您的個人資料的方式，或對您行使上述權利後所收到的回覆不滿意，您有權向您居住國的個人資料保護主管機關提出申訴。</p>
                            <p>聯絡我們</p>
                            <p>5.7如果您對本聲明有任何疑問，可透過「聯絡我們」與我們聯繫。</p>
                        </div>
                        <div id="a06" className="static-content__item">
                            <h4>6.關於隱私權條款變更</h4>
                            <p>6.1我們可能會變更個人資料處理方式，本條款亦可能不定期更新。如有變更，我們會於下方更新最後修改日期。若有重大變更，我們將在網站上明確標示。</p>
                            <p>6.2本條款最近更新日期為2025年7月4日。</p>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    render() {
        const { privacyPolicy } = this.props;
        const isNotEmptyObject = privacyPolicy && Object.keys(privacyPolicy).length > 0;

        return (
            <React.Fragment>
                <Header toggleLoginMessageModal={this.toggleLoginMessageModal} />
                <div className="header__Placeholder"></div>
                <div className="m__wrap">
                    <div className="m__contents">
                        {isNotEmptyObject ? (
                            <section className="static-content">
                                {parse(privacyPolicy.html)}
                            </section>
                        ) : (
                            this.defaultContent()
                        )}
                    </div>
                </div>
                <Footer />
                <MessageModal
                    ref={this.messageModalRef}
                    mode={this.state.message.mode}
                    title={this.state.message.title}
                    message={this.state.message.body}
                />
            </React.Fragment>
        );
    }
}

PrivacyContainer.propTypes = {
    privacyPolicy: PropTypes.object,
};

PrivacyContainer.defaultProps = {
    privacyPolicy: {},
};

function mapStateToProps(state) {
    return {
        privacyPolicy: state.access.privacyPolicy,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getPrivacyPolicy: () => {
            return dispatch(getPrivacyPolicy());
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PrivacyContainer);
